import http from "@/shared/services/http";

export const listBillLadingManageCod = (params: any) =>  http.get(`v1/customer/manage-cod`, { params });
